import { render, staticRenderFns } from "./EditCampoPartido.vue?vue&type=template&id=3cca30b9&scoped=true&"
import script from "./EditCampoPartido.vue?vue&type=script&lang=js&"
export * from "./EditCampoPartido.vue?vue&type=script&lang=js&"
import style0 from "./EditCampoPartido.vue?vue&type=style&index=0&id=3cca30b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cca30b9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VCombobox } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTimePicker } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardTitle,
  VCombobox,
  VDatePicker,
  VDialog,
  VIcon,
  VMenu,
  VSpacer,
  VTextField,
  VTimePicker,
})
